import useMutationChangeStatus from './counter-use-mutation-change-status';
import useMutationUpdateStatus from './counter-use-mutation-update-status';



export const counterUseMutation = {
  counterChange: useMutationChangeStatus,
  counterUpdate: useMutationUpdateStatus,
}